import { InboxModel } from '../models/inbox.model';
import { MessageModel } from '../models/message.model';

export function toInboxModel(data: any): InboxModel {
  let response = new InboxModel();
  response.id = data.id;
  if (data.fechaLeido) {
    response.setReadDate(new Date(data.fechaLeido));
  }
  response.mensajesId = toUserMessageModel(data.mensajesId);
  return response;
}

export function toInboxModelCollection(collection: any[]): InboxModel[] {
  let response = new Array<InboxModel>();
  collection.forEach((data) => {
    response.push(toInboxModel(data));
  });
  return response;
}

export function toUserMessageModel(data: any): MessageModel {
  let response = new MessageModel();
  response.id = data.id;
  response.fechaDesde = new Date(data.fechaDesde);
  response.mensaje = data.mensaje;
  response.titulo = data.titulo;
  return response;
}
